export default "__VITE_ASSET__BPwPdQxW__"